export default {
  Export: {
    ListStudentJoinToExam: 'Danh sách học sinh tham gia thi'
  }
}
